import BreadCrumb from "Components/Common/BreadCrumb";
import React, { useCallback, useState } from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import {
    Container,
    CardBody,
    Card,
    Input,
    Label,
} from "reactstrap";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import ImageViewer from "Components/Common/ImageViewer";

const BusinessInformation = () => {
    document.title = "Business Information | BuyPass";

    const selectuserProfile = createSelector(
        (state: any) => state.Business,
        (business) => business?.business
    );
    const seller = useSelector(selectuserProfile);

    useEffect(() => {
    }, [seller]);

    const [isViewerOpen, setViewerOpen] = useState(false);
    const [currentImage, setCurrentImage] = useState("");


    const openViewer = (imageUrl: string) => {
        setCurrentImage(imageUrl);
        setViewerOpen(true);
    };

    const closeViewer = () => {
        setViewerOpen(false);
    };

    return (
        <div className="page-content">
            <Container fluid>
                <BreadCrumb title=" Business Information" pageTitle="My-Account" pageTitleRoute="/my-account-setting" />
                <Card>
                    <CardBody className="rounded-3">
                        <div className="d-grid gap-3 BussinessInformation" >
                            <div >
                                <h6 className="fw-bold ">Seller Type</h6>
                                <p className="m-0 p-0">
                                    {seller?.sellerType ? seller?.sellerType.charAt(0).toUpperCase() + seller?.sellerType.slice(1) : "--"}
                                    </p>

                            </div>

                            <div >
                                <h6 className="fw-bold ">Legal Company Name<span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                <p className="m-0 p-0">{seller?.idBankDetails?.companyLegalName || "--"}
                                    {/* <span className="text-success cursor-pointer ms-2">Modify</span> */}
                                </p>
                            </div>



                            <div >
                                <h6 className="fw-bold ">Country/ Region<span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                {/* <p className="m-0 p-0">{seller?.country || "pakistan"} */}
                                <p className="m-0 p-0">
                                    {seller?.country ? seller?.country.charAt(0).toUpperCase() + seller?.country.slice(1) : "Pakistan"}
                                    </p>
                                {/* </p> */}
                            </div>

                            <div >
                                <h6 className="fw-bold ">Person in Charge<span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                <p className="m-0 p-0">{seller?.personInCharge?.personInCharge || "--"}
                                </p>
                            </div>

                            <div >
                                <h6 className="fw-bold ">Person in Email<span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                <p className="m-0 p-0">{seller?.personInCharge?.personInChargeEmail || "--"}
                                </p>
                            </div>

                            <div >
                                <h6 className="fw-bold ">Business Registration Number<span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                <p className="m-0 p-0">{seller?.idBankDetails?.businessRegistrationNumber || "--"}
                                </p>
                            </div>

                            <div >
                                <h6 className="fw-bold ">Upload ID - Front Side<span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                <div>
                                    {seller?.nationality?.cnicFrontImage?.url ? (
                                        <img
                                            src={seller.nationality.cnicFrontImage.url}
                                            alt="CNIC Back"
                                            className="img-fluid cursor-pointer"
                                            style={{ width: "200px", height: "100px" }}
                                            onClick={() => openViewer(seller.nationality.cnicFrontImage.url)}
                                        />
                                    ) : (
                                        <div>
                                            <p className="m-0 p-0">--</p>
                                            <button type="button" className="btn btn-light" data-testing-Id="uploadFrontSideButton_businessInformation"> Upload </button>
                                        </div>
                                    )}
                                </div>
                            </div>

                          

                            <div >
                                <h6 className="fw-bold ">Upload ID - Back Side<span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                <div>
                                    {seller?.nationality?.cnicBackImage?.url ? (
                                        <img
                                            src={seller.nationality.cnicBackImage.url}
                                            alt="CNIC Back"
                                            className="img-fluid cursor-pointer"
                                            style={{ width: "200px", height: "100px"  }}
                                            onClick={() => openViewer(seller.nationality.cnicBackImage.url)}
                                        />
                                    ) : (
                                        <div>
                                            <p className="m-0 p-0">--</p>
                                            <button type="button" className="btn btn-light" data-testing-Id="uploadBackSideButton_businessInformation"> Upload </button>
                                        </div>
                                    )}
                                </div>

                            </div>
                            {seller?.accountType === "business" && 
                            <div >
                                <h6 className="fw-bold ">Upload ID - Trademark certificate<span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                <div>
                                    {seller?.idBankDetails?.businessDocuments[0]?.url ? (
                                        <img
                                            src={seller.idBankDetails.businessDocuments[0].url}
                                            alt="CNIC Back"
                                            className="img-fluid cursor-pointer"
                                            style={{ width: "200px", height: "100px" }}
                                            onClick={() => openViewer(seller.idBankDetails.businessDocuments[0].url)}
                                        />
                                    ) : (
                                        <div>
                                            <p className="m-0 p-0">--</p>
                                            <button type="button" className="btn btn-light" data-testing-Id="uploadFrontSideButton_businessInformation"> Upload </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                            }
                            <div >
                                <h6 className="fw-bold ">CNIC Number<span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                <p className="m-0 p-0">{seller?.nationality?.cnicNumber || "--"}
                                </p>
                            </div>

                            <div>
                                <h6 className="fw-bold">Address <span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                <p className="m-0 p-0">
                                {
                                            seller?.idBankDetails?.isBusinessAddressSame
                                                ? seller?.address?.streetAddress || "--"
                                                : seller?.idBankDetails?.businessAddress?.streetAddress || "--"
                                        }
                                </p>
                            </div>

                            <div>
                                <h6 className="fw-bold">State <span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                <p className="m-0 p-0">
                                    {
                                        seller?.idBankDetails?.isBusinessAddressSame
                                            ? seller?.address?.state || "--"
                                            : seller?.idBankDetails?.businessAddress?.state || "--"
                                    }
                                </p>
                            </div>

                            <div>
                                <h6 className="fw-bold">City <span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                <p className="m-0 p-0">
                                    {
                                        seller?.idBankDetails?.isBusinessAddressSame
                                            ? seller?.address?.city || "--"
                                            : seller?.idBankDetails?.businessAddress?.city || "--"
                                    }
                                </p>
                            </div>

                            <div>
                                <h6 className="fw-bold">Neighborhood <span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                <p className="m-0 p-0">
                                    {
                                        seller?.idBankDetails?.isBusinessAddressSame
                                            ? seller?.address?.neighborhood || "--"
                                            : seller?.idBankDetails?.businessAddress?.neighborhood || "--"
                                    }
                                </p>
                            </div>

                            <div>
                                <h6 className="fw-bold">Plaza Market Name <span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                <p className="m-0 p-0">
                                    {
                                        seller?.idBankDetails?.isBusinessAddressSame
                                            ? seller?.address?.plazaMarketName || "--"
                                            : seller?.idBankDetails?.businessAddress?.plazaMarketName || "--"
                                    }
                                </p>
                            </div>

                            <div>
                                <h6 className="fw-bold">Shop Name <span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                <p className="m-0 p-0">
                                    {
                                        seller?.idBankDetails?.isBusinessAddressSame
                                            ? seller?.address?.shopName || "--"
                                            : seller?.idBankDetails?.businessAddress?.shopName || "--"
                                    }
                                </p>
                            </div>

                            <div>
                                <h6 className="fw-bold">Shop Number <span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                <p className="m-0 p-0">
                                    {
                                        seller?.idBankDetails?.isBusinessAddressSame
                                            ? seller?.address?.shopNumber || "--"
                                            : seller?.idBankDetails?.businessAddress?.shopNumber || "--"
                                    }
                                </p>
                            </div>


                           

                            {seller?.sellerType === "indivisual" && (
                                <div>
                                    <h6 className="fw-bold">
                                        ID Type
                                        <span>
                                            <i className="ri-information-line ms-2 fs-5 fw-normal"></i>
                                        </span>
                                    </h6>
                                    <p className="m-0 p-0">
                                        {seller?.businessDocuments?.type || "CNIC"}
                                    </p>
                                </div>
                            )}

                            <ImageViewer isOpen={isViewerOpen} imageUrl={currentImage} toggle={closeViewer} />


                        </div>

                    </CardBody>
                </Card>
                <Card>
                    <CardBody className="rounded-3 text-end">
                        <Link to="/business-information-modify" className="  ">
                            <button type="button" className="btn btn-secondary" data-testing-Id="modifyButton_businessInformation">Modify</button>
                        </Link>

                    </CardBody>
                </Card>
            </Container>
        </div>
    );
};

export default BusinessInformation;